import { Provider } from 'react-redux';

import Video from './oc-video';
import { store } from '../Store';

const App = props => (
  <Provider store={store}>
    <Video {...props} />
  </Provider>
);

export default App;
